(() => {
  const labels = {style:'Style',evo:'Evo',pro:'Pro',pro_fps:'Pro FPS'};
  const benefits = {style:'Design unique · Sans palettes',evo:'Deux palettes arrière · Commandes X-O ou O-X',pro:'Deux palettes arrière · Remapping des commandes',pro_fps:'Palettes avec remapping · Gâchettes mécaniques'};
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR',{style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(cents/100);
  let i18n = {};
  const init = root => {
    if (root.dataset.collectionReady) return;
    const i18nEl = root.querySelector('[data-burn-collection-i18n]');
    if (i18nEl) { try { i18n = JSON.parse(i18nEl.textContent) || {}; Object.assign(benefits, i18n.benefits || {}); } catch (e) {} }
    root.dataset.collectionReady = 'true';
    const grid=root.querySelector('[data-design-grid]'), count=root.querySelector('[data-design-count]'), empty=root.querySelector('[data-design-empty]');
    const range=root.querySelector('[data-filter-range]'), color=root.querySelector('[data-filter-color]'), price=root.querySelector('[data-filter-price]'), stock=root.querySelector('[data-filter-stock]'), sort=root.querySelector('[data-collection-sort]'), reset=root.querySelector('[data-filter-reset]');
    const dialog=root.querySelector('[data-design-dialog]');
    let opener;
    const cards=[...root.querySelectorAll('[data-design-card]')].map(card=>{
      let products;
      try {products=JSON.parse(card.querySelector('[data-design-products]').textContent);} catch {return null;}
      if(!Array.isArray(products))return null;
      return {card,products,current:products[0]?.range,radios:[...card.querySelectorAll('[data-design-range]')],order:Number(card.dataset.originalOrder)};
    }).filter(item=>item?.products.length);
    // Filters only offer ranges and designs present in this collection.
    [...range.options].forEach(option=>{if(option.value!=='all'&&!cards.some(item=>item.products.some(p=>p.range===option.value)))option.remove();});
    [...new Set(cards.map(item=>item.card.dataset.color))].filter(Boolean).sort((a,b)=>a.localeCompare(b,'fr')).forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;color.append(option);});
    const selected=item=>item.products.find(p=>p.range===item.current) || item.products[0];
    const urlFor=p=>{
      const url=new URL(p.url,window.location.origin);
      url.searchParams.set('view',`burn-${p.range.replace('_','-')}`);
      if (root.dataset.previewTheme) url.searchParams.set('preview_theme_id',root.dataset.previewTheme);
      return url.pathname+url.search;
    };
    const updateCard=item=>{
      const p=selected(item),c=item.card;
      item.radios.forEach(radio=>{radio.checked=radio.value===p.range;radio.closest('.burn-design__range-choice').classList.toggle('is-selected',radio.checked);});
      c.querySelector('[data-design-price]').textContent=money(p.price);
      c.querySelector('[data-design-benefit]').textContent=benefits[p.range];
      c.querySelector('[data-design-stock]').textContent=p.available?(i18n.available || 'Disponible'):(i18n.unavailable || 'Indisponible');
      c.querySelector('[data-design-link]').href=urlFor(p);
      c.querySelector('[data-design-link]').innerHTML=`${i18n.view || 'Voir la manette'} <span aria-hidden="true">↗</span>`;
      c.querySelector('[data-design-image-link]').href=urlFor(p);
      const image=c.querySelector('.burn-design__image');
      if(image){image.hidden=!p.image;image.removeAttribute('srcset');if(p.image)image.src=p.image;else image.removeAttribute('src');image.alt=p.alt||p.title;}
    };
    const apply=()=>{
      const limit=price.value===''?Infinity:Math.max(0,Number(price.value))*100;
      let shown=0;
      cards.forEach(item=>{
        if(range.value!=='all' && item.products.some(p=>p.range===range.value)) item.current=range.value;
        updateCard(item);
        const p=selected(item);
        const visible=(range.value==='all'||p.range===range.value)&&(color.value==='all'||item.card.dataset.color===color.value)&&p.price<=limit&&(!stock.checked||p.available);
        item.card.hidden=!visible;
        if(visible)shown++;
      });
      const ordered=[...cards].sort((a,b)=>{
        const x=selected(a),y=selected(b);
        switch(sort.value){
          case 'price-ascending':return x.price-y.price||a.order-b.order;
          case 'price-descending':return y.price-x.price||a.order-b.order;
          case 'created-descending':return Number(y.created)-Number(x.created)||a.order-b.order;
          case 'best-selling':return (x.rank<0?Infinity:x.rank)-(y.rank<0?Infinity:y.rank)||a.order-b.order;
          default:return a.order-b.order;
        }
      });
      const cardsMoved=ordered.some((item,index)=>grid.children[index]!==item.card);
      if(cardsMoved){
        const active=document.activeElement;
        const anchor=active?.matches('[data-design-range]')?active.closest('[data-design-card]'):null;
        const top=anchor?.getBoundingClientRect().top;
        ordered.forEach((item,index)=>{
          if(grid.children[index]!==item.card)grid.insertBefore(item.card,grid.children[index] || null);
        });
        if(anchor && !anchor.hidden){
          active.focus({preventScroll:true});
          window.scrollBy(0,anchor.getBoundingClientRect().top-top);
        }
      }
      count.textContent=`${shown} ${shown>1 ? (i18n.design_other || 'designs') : (i18n.design_one || 'design')}`;
      empty.hidden=shown!==0;
      reset.hidden=range.value==='all'&&color.value==='all'&&price.value===''&&!stock.checked;
    };
    const salesOption=root.querySelector('[data-sort-sales]');
    salesOption.disabled=!cards.some(item=>item.products.some(p=>p.member));
    const params=new URL(window.location.href).searchParams;
    if(params.get('sort_by')==='best-selling'&&!salesOption.disabled)sort.value='best-selling';
    if(labels[params.get('burn_range')])range.value=params.get('burn_range');
    if([...color.options].some(o=>o.value===params.get('burn_color')))color.value=params.get('burn_color');
    if(params.has('burn_price'))price.value=params.get('burn_price');
    stock.checked=params.get('burn_stock')==='1';
    [range,color,price,stock].forEach(control=>control.addEventListener('input',apply));
    sort.addEventListener('change',()=>{
      if(sort.value==='best-selling'&&!cards.some(item=>item.products.some(p=>p.rank>=0))){
        const url=new URL(window.location.href);url.searchParams.set('sort_by','best-selling');
        for(const [key,value] of [['burn_range',range.value],['burn_color',color.value],['burn_price',price.value],['burn_stock',stock.checked?'1':'0']])url.searchParams.set(key,value);
        window.location.assign(url.pathname+url.search+url.hash);
      }else apply();
    });
    reset.addEventListener('click',()=>{range.value='all';color.value='all';price.value='';stock.checked=false;cards.forEach(item=>item.current=item.products[0].range);apply();});
    cards.forEach(item=>{
      item.radios.forEach(radio=>radio.addEventListener('change',()=>{if(radio.checked){item.current=radio.value;range.value='all';apply();}}));
      const singleRange = item.products.length < 2;
      item.card.dataset.singleRange = String(singleRange);
      item.card.querySelector('[data-design-range-control]').hidden = singleRange;
      const quick=item.card.querySelector('[data-design-quick]');
      if(dialog?.showModal){
        quick.hidden=false;
        quick.addEventListener('click',()=>{
          const p=selected(item);opener=quick;
          const dialogImage=dialog.querySelector('[data-dialog-image]');dialogImage.hidden=!p.image;if(p.image)dialogImage.src=p.image;else dialogImage.removeAttribute('src');
          dialog.querySelector('[data-dialog-image]').alt=p.alt || p.title;
          dialog.querySelector('[data-dialog-title]').textContent=`${item.card.dataset.name} · ${labels[p.range]}`;
          dialog.querySelector('[data-dialog-benefit]').textContent=benefits[p.range];
          dialog.querySelector('[data-dialog-price]').textContent=money(p.price);
          dialog.querySelector('[data-dialog-link]').href=urlFor(p);
          dialog.showModal();
        });
      }
    });
    dialog?.querySelector('[data-dialog-close]').addEventListener('click',()=>dialog.close());
    dialog?.addEventListener('close',()=>opener?.focus());
    root.querySelector('[data-collection-controls]').hidden=false;
    apply();
  };
  const scan=()=>document.querySelectorAll('[data-burn-collection]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
